import React from 'react'
import { SigurModalSearch } from "../lib/SigurModalSearch";

/** Модалка поиска без кнопки «Сохранить в отбор». */
export class ApprovalsModalSearch extends SigurModalSearch {
  renderSaveSearch() {
    return null
  }
}
